import { useEffect } from 'react';
import { CheckCircle2, LayoutDashboard, ArrowRight, ShieldCheck, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import confetti from 'canvas-confetti';
import VerificationBadge from './CampusUnlockCard';
import { loadUser } from '../../Actions/user';
import { useDispatch } from 'react-redux';

export const SuccessStep = ({ formData = {} }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Trigger a subtle confetti pop on mount for the "Wow" factor
  useEffect(() => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: ['#2563eb', '#10b981', '#ffffff'] // Blue, Green, White
    });
  }, []);

  const handleCompleteandGoHome = (e) => {
    if (e) e.currentTarget.disabled = true;
    window.location.assign('/');
  };


  const userName = formData?.fullName || 'User';
  const firstName = userName.split(' ')[0];

  return (
    <div className="flex flex-col items-center w-full max-w-lg mx-auto py-8 px-6 animate-in fade-in slide-in-from-bottom-8 duration-1000">
      
      {/* 1. Completion Indicator (Replaces the 'lines') */}
      {/* <div className="w-full max-w-[200px] mb-12">
        <div className="flex justify-between items-center mb-2">
          <span className="text-[10px] font-black text-blue-600 uppercase tracking-[0.2em]">Profile Status</span>
          <span className="text-[10px] font-black text-green-600 uppercase tracking-[0.2em]">100%</span>
        </div>
        <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
          <div className="h-full bg-green-500 rounded-full animate-progress-grow"></div>
        </div>
      </div> */}

      {/* 2. The Success Icon & Name Greeting */}
      <div className="text-center space-y-4 mb-10">
        <div className="relative inline-block">
          <div className="bg-green-100 text-green-600 p-4 rounded-full relative z-10 shadow-lg shadow-green-100/50">
            <CheckCircle2 size={48} strokeWidth={2.5} />
          </div>
          {/* Subtle Blue Glow behind the green check */}
          <div className="absolute inset-0 bg-blue-400/20 rounded-full blur-2xl scale-150 animate-pulse"></div>
        </div>
        
       <div className="space-y-4 text-center px-6">
  {/* The Action Line */}
  <div className="space-y-1">
    <p className="text-slate-500 font-bold text-sm md:text-base leading-relaxed">
      Welcome to the community.
    </p>
    
    {/* The Value List - Simple & Clean */}
    <p className="text-slate-900 font-black text-[11px] md:text-xs uppercase tracking-[0.15em] opacity-80">
      Start exploring interview experiences • study material • job alerts
    </p>
  </div>
</div>
      </div>

      {/* 3. The Professional "Identity Card" */}
      <div className="w-full bg-white rounded-[2.5rem] p-8 shadow-2xl shadow-blue-900/10 border border-slate-50 flex flex-col items-center relative overflow-hidden group">
        
        {/* Subtle Decorative Background Element */}
        <div className="absolute -top-10 -right-10 w-32 h-32 bg-blue-50 rounded-full blur-3xl opacity-50 group-hover:opacity-100 transition-opacity"></div>

        {/* User Identity Section */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-24 h-24 rounded-full border-4 border-white shadow-xl overflow-hidden mb-4 bg-slate-50">
            {formData.profileImage ? (
              <img src={formData.profileImage} alt={userName} className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-blue-600 text-white text-3xl font-black">
                {firstName.charAt(0)}
              </div>
            )}
          </div>
          <div className="text-center">
            <h3 className="text-lg font-black text-slate-800 uppercase tracking-tight">{userName}</h3>
            <div className="flex items-center justify-center space-x-2 mt-1">
               <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{formData.role || 'Member'}</span>
               <span className="w-1 h-1 bg-slate-300 rounded-full"></span>
               <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{formData.collegeName || 'CampusIra'}</span>
            </div>
          </div>
        </div>

        {/* Action Button */}
        <button 
          onClick={() => {handleCompleteandGoHome()}}
          className="w-full group relative py-4 bg-slate-900 hover:bg-blue-600 text-white font-black rounded-2xl text-xs uppercase tracking-[0.2em] shadow-xl transition-all flex items-center justify-center space-x-3 active:scale-95"
        >
          <LayoutDashboard size={16} />
          <span>Go to home</span>
          <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
        </button>
      </div>

           
        {!formData.isCollegeVerified && (
         <VerificationBadge collegeName={formData.collegeName} onVerify={() => alert('Verification flow coming soon!')} />
        )}

      {/* CSS for the Progress Bar Animation */}
      <style>{`
        @keyframes progress-grow {
          from { width: 60%; }
          to { width: 100%; }
        }
        .animate-progress-grow {
          animation: progress-grow 1.5s ease-out forwards;
        }
      `}</style>
    </div>
  );
};